import React from 'react';
import { List, Typography, Icon } from "antd";
import { Row } from 'reactstrap'
import conversationsListStyles from "../../../../../assets/ConversationsList.module.css";
import conversationsItemStyles from "../../../../../assets/ConversationsItem.module.scss";
import { joinClassNames } from "../../../../../helpers/Utils";
import ChatIcon from "./ChatIcon";
import { Colxx } from '../../../../../components/common/CustomBootstrap';
const { Text } = Typography;

export class TwilioConversationList extends React.Component {
    render() {
        const { conversations, selectedConversationSid, onConversationClick, closeConversation } = this.props;

        return (
            <List
                className={conversationsListStyles['conversations-list']}
                bordered={true}
                style={{ margin: '10px' }}
                locale={{ emptyText: 'There is no ongoing conversations at this moment' }}
                dataSource={conversations}
                renderItem={item => {
                    // console.log("item", item.channelState.dateUpdated.toLocaleString())
                    const activeChannel = item.sid === selectedConversationSid;
                    const conversationItemClassName = joinClassNames([
                        conversationsItemStyles['conversation-item'],
                        activeChannel && conversationsItemStyles['conversation-item--active']
                    ]);

                    return (
                        <List.Item
                            key={item.sid}
                            className={conversationItemClassName}
                            onClick={event => onConversationClick(item, event)}
                            style={{ cursor: 'pointer' }}
                        >
                            <Text
                                strong
                                className={conversationsItemStyles['conversation-item-text']}
                            >
                                {item.friendlyName || item.sid}
                                <br />
                                <span style={{ fontSize: '10px' }}> {item.channelState.dateUpdated.toLocaleString()} </span>
                            </Text>

                        </List.Item>
                    )
                }}
            />
        )
    }
}
